import { Container } from '@mui/material'
import {
  DelekWarrantyExtensionsResponse,
  GetWarrantyExtensions,
} from "api/delek"
import { CommonForm, CommonInputSearch } from "common/forms"
import { memo, useState } from "react"
import WarrantyExtensions from "./WarrantyExtensions"
import WarrantyExtensionsSchema, {
  initialFormState,
} from "./WarrantyExtensionsSchema"

const WarrantyExtensionsForm = () => {
  const [response, setResponse] = useState<DelekWarrantyExtensionsResponse>(
    null
  )
  return (
    <>
      <CommonForm
        initialValues={initialFormState}
        validationSchema={WarrantyExtensionsSchema}
        onSubmit={async (values) => {
          const { data } = await GetWarrantyExtensions(values.licenceOrChassis)
          setResponse(data)
        }}
        render={() => (
          <Container>
            <CommonInputSearch
              placeholder="הקלד מס׳ רישוי או שילדה"
              name="licenceOrChassis"
            />
          </Container>
        )}
      />
      {response?.result && <WarrantyExtensions data={response.data} />}
    </>
  )
}

export default memo(WarrantyExtensionsForm)
